import { h, Component } from 'preact';
import pure from 'utils/pure';


export default @pure class Preloader extends Component {

	getPreloader = () => {
		return '';
	};

	render({ preloader }) {
		if (preloader) {
			// Show the preloader
			this.getPreloader();
		} else {
			// No Preloader
			return '';
		}
	}

}
